var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_34401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00195 7.25C6.86388 7.25 6.75195 7.13807 6.75195 7C6.75195 6.86193 6.86388 6.75 7.00195 6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00195 7.25C7.14002 7.25 7.25195 7.13807 7.25195 7C7.25195 6.86193 7.14002 6.75 7.00195 6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25195 7.25C4.11388 7.25 4.00195 7.13807 4.00195 7C4.00195 6.86193 4.11388 6.75 4.25195 6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25195 7.25C4.39002 7.25 4.50195 7.13807 4.50195 7C4.50195 6.86193 4.39002 6.75 4.25195 6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75195 7.25C9.61388 7.25 9.50195 7.13807 9.50195 7C9.50195 6.86193 9.61388 6.75 9.75195 6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75195 7.25C9.89002 7.25 10.002 7.13807 10.002 7C10.002 6.86193 9.89002 6.75 9.75195 6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99815 0.560548C5.83333 0.560911 4.69041 0.877215 3.69113 1.47577C2.69186 2.07433 1.87365 2.93272 1.32365 3.95952C0.773648 4.98632 0.512458 6.14308 0.567896 7.30658C0.623333 8.47009 0.993323 9.59677 1.63846 10.5666L0.558594 13.4397L4.17465 12.7858C5.04539 13.2113 6.00093 13.4348 6.97006 13.4396C7.93919 13.4444 8.8969 13.2304 9.77181 12.8135C10.6467 12.3967 11.4163 11.7877 12.023 11.032C12.6298 10.2764 13.0583 9.3935 13.2763 8.44921C13.4944 7.50493 13.4966 6.5236 13.2826 5.57838C13.0686 4.63315 12.6441 3.74841 12.0406 2.99011C11.4371 2.2318 10.6702 1.6195 9.79714 1.19883C8.92406 0.778157 7.96729 0.559976 6.99815 0.560548Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_34401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.770c1756e4c3af30dcd7a0dcd9b83aba.svg";
export { ForwardRef as ReactComponent };